import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import PageCard from './PageCard.tsx';
import { Avatar, Box, FormLabel, Pagination, Skeleton, Typography } from '@mui/material';
import { IEntity } from '../../interfaces/campaign.ts';
import GroupsIcon from '@mui/icons-material/Groups';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

export default function ShowPagesModal({ id }: { id: number }) {
	const { t } = useTranslation();

	const skeletonBody = (
		<Box className="relative flex w-64 flex-col items-center justify-center rounded-2xl border border-grey-300 p-4">
			<Avatar src={''} className="absolute right-3 top-3 h-12 w-12" />
			<Avatar className="mb-4 h-28 w-28" />
			<Box className="flex w-full items-center justify-between gap-4 border-b py-2">
				<Box className="flex items-center">
					<FormLabel className="text-base font-medium text-text-primary">
						<Skeleton className={'w-full'} />
					</FormLabel>
				</Box>
				<Skeleton className={'w-full grow'} />
			</Box>
			<Box className="flex w-full items-center justify-between border-b pb-2 pt-3">
				<Box className="flex items-center">
					<GroupsIcon className="me-2 h-5 w-5 text-grey-400" />
					<Typography className="text-sm text-text-secondary">{t('member_count')}</Typography>
				</Box>
				<Skeleton className={'w-full grow'} />
			</Box>
			<Box className="flex w-full items-center justify-between border-b pb-2 pt-3">
				<Box className="flex items-center">
					<LocationOnIcon className="me-2 h-5 w-5 text-grey-400" />
					<Typography className="text-sm text-text-secondary">{t('location')}</Typography>
				</Box>
				<Skeleton className={'w-full grow'} />
			</Box>
			<Box className="flex w-full items-center justify-between border-b pb-2 pt-3">
				<Box className="flex items-center">
					<InsertChartIcon className="me-2 h-5 w-5 text-grey-400" />
					<Typography className="text-sm text-text-secondary">{t('er')}</Typography>
				</Box>
				<Skeleton className={'w-full grow'} />
			</Box>
			<Box className="flex w-full items-center justify-between border-b pb-2 pt-3">
				<Box className="flex items-center">
					<ContentPasteIcon className="me-2 h-5 w-5 text-grey-400" />
					<Typography className="text-sm text-text-secondary">{t('content')}</Typography>
				</Box>
				<Skeleton className={'w-full grow'} />
			</Box>
			<Box className="flex w-full items-center justify-between pb-2 pt-3">
				<Box className="flex items-center">
					<AccountBalanceWalletIcon className="me-2 h-5 w-5 text-grey-400" />
					<Typography className="text-sm text-text-secondary">{t('price')}</Typography>
				</Box>
				<Skeleton className={'w-full grow'} />
			</Box>
		</Box>
	);

	const [data, setData] = useState<(IEntity | null)[]>([null, null, null, null, null, null]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(1);

	useEffect(() => {
		axios({
			method: 'GET',
			url: `/media_packages/${id}`,
		}).then(r => {
			if (r?.data?.success) {
				setData(r?.data?.data);
				setTotal(r?.data?.pagination?.total);
			}
		});
	}, []);

	const changePage = (_: React.ChangeEvent<unknown>, newPage: number) => {
		setPage(newPage);
	};

	return (
		<Box className="mt-4">
			<Box className={'relative flex min-h-16 flex-wrap items-center gap-x-4 gap-y-6'}>{data.length === 0 ? <Typography className="center text-base">{t('no_page')}</Typography> : data.map(d => (d === null ? skeletonBody : <PageCard key={d.id} {...d} onSelect={() => {}} checkbox={false} />))}</Box>
			{total > 10 && (
				<Box className={'mt-3 flex'}>
					<Pagination count={Math.ceil(total! / 10)} page={page + 1} onChange={changePage} variant="text" showFirstButton={false} showLastButton={false} className="flex justify-center" size="medium" shape="rounded" color="primary" />
				</Box>
			)}
		</Box>
	);
}
